import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MegaMenuComponent } from './mega-menu.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import 'iconify-icon';


@NgModule({
    declarations: [MegaMenuComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        RouterModule
    ],
    exports: [MegaMenuComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA] // 👈 Add this line
})
export class MegaMenuModule { }
